import axios from "axios";
import { AdminEventsApi, type EventDto } from "mws-catalog-ts-sdk";
import { defineStore } from "pinia";

import { usePlatformStore } from "@/platforms/store";

const catalogApiUrl = import.meta.env.VITE_CATALOG_API;
const adminEventsApi = new AdminEventsApi(undefined, catalogApiUrl, axios);

export const useEventStore = defineStore("events", {
  state: (): {
    events: Record<EventDto["id"], EventDto>;
  } => ({
    events: {}, // Pool of events. The components that will display or use sweepstakes will get them from here
  }),
  getters: {},
  actions: {
    async search(searchTerm: string, pageSize = 25, offset = 0) {
      const platformStore = usePlatformStore();

      const response = await adminEventsApi.adminEventsSearchGet({
        xPlatformKey: platformStore.platformKey,
        searchTerm,
        pageSize,
        offSet: offset,
      });

      response.data.results.forEach((event) => {
        this.events[event.id] = event;
      });

      return response.data;
    },
  },
});
